export default __webpack_public_path__ + "static/media/node.d9f098c7.png";